import React from 'react';

import { Info } from 'lucide-react';

const SUGGESTIONS = [
  {
    icon: '💸',
    title: 'Cost vs Industry Benchmark',
    content: 'Your average cost per volunteer is 12% lower than the industry median for similar programs.',
    tip: 'CORAA tracks 2,000+ companies for benchmarking.',
  },
  {
    icon: '🔄',
    title: 'Portfolio Optimization',
    content: 'Try increasing "Skills-based" volunteering to boost beneficiary impact by 18% with minimal budget increase.',
    tip: 'Mix suggestions are based on maximizing reach and retention.',
  },
  {
    icon: '📈',
    title: 'Trends from 2,000+ Companies',
    content: 'Team-based volunteering is up 22% YoY. Companies offering paid volunteer leave see 9% higher engagement.',
    tip: 'Trends are updated quarterly from CORAA data.',
  },
  {
    icon: '🌍',
    title: 'Campaign Ideas for Key Months',
    content: 'April: Earth Day (environmental activities). September: Literacy Month (education-focused events).',
    tip: 'Align campaigns with UN Observance Days for more impact.',
  },
];

import { CalculatorMetrics } from './BudgetCalculatorCalculatedMetricsSection';

interface Props {
  metrics: CalculatorMetrics;
}

const BudgetCalculatorCoraaSuggestionsSection: React.FC<Props> = ({ metrics }) => {
  return (
    <section className="mb-8 p-4 bg-green-50 rounded-lg shadow border border-green-200">
      <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
        <span role="img" aria-label="ai">🧠</span> CORAA Smart Suggestions
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {SUGGESTIONS.map((s, i) => (
          <div key={i} className="bg-white rounded-lg border border-green-200 p-4 flex flex-col gap-2 shadow">
            <div className="flex items-center gap-2">
              <span className="text-2xl">{s.icon}</span>
              <span className="font-semibold text-green-700 text-lg">{s.title}</span>
              <span className="relative group cursor-pointer ml-1">
                <Info className="h-4 w-4 text-green-400" />
                <span className="absolute left-6 top-0 z-10 hidden group-hover:block bg-white border border-green-300 text-xs text-gray-700 rounded px-2 py-1 shadow-lg w-64">
                  {s.tip}
                </span>
              </span>
            </div>
            <div className="text-gray-700 text-sm">{s.content}</div>
          </div>
        ))}
      </div>
      <div className="mt-4 text-xs text-green-700 flex items-center gap-2">
        <span role="img" aria-label="lightbulb">💡</span>
        Did you know? 89% of employees say companies with strong volunteering programs have better culture.
      </div>
    </section>
  );
};

export default BudgetCalculatorCoraaSuggestionsSection;
